import URL from '@/creditflowresearch/Router/urlConstants';
import { AccessGrantMatcher, GrantContext } from './IAccessGrant';

export const LEAGUE_TABLE_PATTERNS = [
  /^\/fixed-income-underwriter-rating-agency-league-table(\/|$)/,
];

const ISSUER_PROFILE_PATTERN = /^\/issuer[-/]\d+[-/]/;
const PARENT_PROFILE_PATTERN = /^\/sponsor[-/]\d+[-/]/;

export const ISSUER_AND_PARENT_PROFILE_PATTERNS = [
  ISSUER_PROFILE_PATTERN,
  PARENT_PROFILE_PATTERN,
];

const INDUSTRY_PUBLIC_PATTERN = /-bond-issuance-overview$/;
const INDUSTRY_INTERNAL_PATTERN = /^\/bond-issuance-overview\//;

export const INDUSTRY_PATTERNS = [
  INDUSTRY_PUBLIC_PATTERN,
  INDUSTRY_INTERNAL_PATTERN,
];

const HYC_MARKET_OVERVIEW_PATTERN = new RegExp(`^${ URL.MARKET_OVERVIEW_HYC }$`);
const IGC_MARKET_OVERVIEW_PATTERN = new RegExp(`^${ URL.MARKET_OVERVIEW_IGC }$`);
const ALL_ABS_MARKET_OVERVIEW_PATTERN = new RegExp(`^${ URL.MARKET_OVERVIEW_ALL }$`);
const CONSUMER_ABS_MARKET_OVERVIEW_PATTERN = new RegExp(`^${ URL.MARKET_OVERVIEW_CONSUMER }$`);
const EM_MARKET_OVERVIEW_PATTERN = new RegExp(`^${ URL.MARKET_OVERVIEW_EM }$`);
const MARKET_OVERVIEW_INTERNAL_PATTERN = /^\/market-all\//;
const ABS_SECTOR_PUBLIC_PATTERN = /-abs-bond-issuance-overview$/;
const ABS_SECTOR_INTERNAL_PATTERN = /^\/abs-bond-issuance-overview\//;

// TODO: remove when the European market opening period ends; only useIsTileSubscribeLocked reads it
export const MARKET_OVERVIEW_PATTERNS = [
  HYC_MARKET_OVERVIEW_PATTERN,
  IGC_MARKET_OVERVIEW_PATTERN,
  EM_MARKET_OVERVIEW_PATTERN,
  ALL_ABS_MARKET_OVERVIEW_PATTERN,
  CONSUMER_ABS_MARKET_OVERVIEW_PATTERN,
];

export const NON_INDUSTRY_OVERVIEW_PATTERNS = [
  HYC_MARKET_OVERVIEW_PATTERN,
  IGC_MARKET_OVERVIEW_PATTERN,
  ALL_ABS_MARKET_OVERVIEW_PATTERN,
  CONSUMER_ABS_MARKET_OVERVIEW_PATTERN,
  MARKET_OVERVIEW_INTERNAL_PATTERN,
  ABS_SECTOR_PUBLIC_PATTERN,
  ABS_SECTOR_INTERNAL_PATTERN,
];

const DEAL_CARD_PUBLIC_PATTERN = /^\/deal[-/]\d+[-/]/;
const DEAL_CARD_INTERNAL_PATTERN = new RegExp(`^${ URL.DEAL }/`);

export const DEAL_CARD_PATTERNS = [
  DEAL_CARD_PUBLIC_PATTERN,
  DEAL_CARD_INTERNAL_PATTERN,
];

export const matchByPagePath = (...patterns: RegExp[]): AccessGrantMatcher =>
  (context) => {
    const pathnameWithoutQuery = (context.pathname as string | undefined)?.split('?')[0];

    return pathnameWithoutQuery ? patterns.some((pattern) => pattern.test(pathnameWithoutQuery)) : false;
  };

export const PATH_ONLY_GRANT_CONTEXT: Partial<GrantContext> = { marketIds: [] };
